import { REQUEST_OCCUPATIONS_REL } from './constants'

export const searchOccupationsRelSelector = (state) =>
  state.links.filter((link) => link.Rel === REQUEST_OCCUPATIONS_REL)[0]
